import domain, { baseDomain } from '@liepin/native-domain-fe';
export const rootDomain = baseDomain;
export const cRoot = domain('c');
export const wwwRoot = domain('www');
